/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyTagDto } from '../../models/company-tag-dto';

export interface GetTagsByCompany$Params {
  id: number;
}

export function getTagsByCompany(http: HttpClient, rootUrl: string, params: GetTagsByCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyTagDto>>> {
  const rb = new RequestBuilder(rootUrl, getTagsByCompany.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyTagDto>>;
    })
  );
}

getTagsByCompany.PATH = '/api/company/{id}/tags';
